const initBrokersProjects = () => {
	const sections = document.querySelectorAll("section.brokers-projects");
    console.log(sections);

	if (sections.length) {
		Array.from(sections).forEach((section) => {
			const textBlocks = section.querySelectorAll(".text")
            console.log(textBlocks);

			textBlocks.forEach((textBlock) => {
				const collapseBtn = textBlock.querySelector(".collapse");

				textBlock.addEventListener("click", (e) => {
					if (
						textBlock.dataset.collaped === "false" ||
						e.target === collapseBtn
					)
						return;

					textBlock.dataset.collaped = "false";
				});

				if (collapseBtn) {
					collapseBtn.addEventListener("click", (e) => {
						e.stopPropagation();
						textBlock.dataset.collaped = "true";
					});
				}
			});
		});
	}
};

export { initBrokersProjects };
